import * as React from "react"

import { cn } from "@/lib/utils"
import { SIDEBAR_BRAND_LOGO_EXPANDED_SRC } from "@/constants/sidebarBrandLogo"

export function AuthBrandHero({ className }: { className?: string }) {
  return (
    <div
      data-auth-brand-hero
      className={cn("relative hidden h-full min-h-[280px] md:block", className)}
      aria-hidden
    >
      <div
        className="absolute inset-0"
        style={{
          background: "linear-gradient(135deg, rgb(56, 187, 209), rgb(62, 234, 236))",
        }}
      />
      <img
        src={SIDEBAR_BRAND_LOGO_EXPANDED_SRC}
        alt=""
        className="absolute inset-0 m-auto h-auto w-[70%] max-w-[280px] object-contain p-10 brightness-0 invert"
        decoding="async"
      />
    </div>
  )
}
